import { CDN_URL } from '@/constants/site'

const photo = (file: string): string => `${CDN_URL}/portfolio/photos/${file}`

export type MediaAsset = {
    src: string
    alt: string
}

export const media = {
    portraitDark: { src: photo('iza-portrait-dark.jpg'), alt: 'Iza Faroza mengenakan jas almamater STIKOM El Rahma dengan tangan bersedekap' },
    portraitFormal: { src: photo('iza-formal-red.jpg'), alt: 'Foto formal Iza Faroza dengan jas almamater di depan latar merah' },
    presenting: { src: photo('iza-presentasi-stikom.jpg'), alt: 'Iza Faroza mempresentasikan proyek di depan laptop di ruang kelas STIKOM El Rahma' },
    laptop: { src: photo('iza-laptop.jpg'), alt: 'Iza Faroza berkacamata mengambil swafoto di depan layar laptop' },
    hoodie: { src: photo('iza-hoodie.jpg'), alt: 'Iza Faroza memakai hoodie hitam berfoto di depan cermin dengan cahaya lampu ponsel' },
    teaching: { src: photo('iza-mengajar-mi.jpg'), alt: 'Iza Faroza membimbing siswa yang sedang menulis di kelas MI Tarbiyatul Falah' }
} satisfies Record<string, MediaAsset>

export const filmStrip: MediaAsset[] = [
    media.presenting,
    media.portraitFormal,
    media.teaching,
    media.laptop,
    media.hoodie,
    media.portraitDark
]
